import React, { Component } from 'react'
// import { Link } from 'react-router-dom'
import ReactHtmlParser from 'react-html-parser'
import { format } from 'date-fns'
// import Settings from '../settings'

// This component has:
// 1. Text area

import IconSquare from './icons/IconSquare'
import gradient_oval from '../images/gradient-oval.png'

class SectionFeaturedEvents extends Component {

   constructor() {
      super()
      this.state = {
         open: 0,
         events: []
      }
   }

   componentDidMount() {
      // this.getEvents()
   }

  //  getEvents = () => {
  //   let dataURL = `${ Settings.api }/events`
  //   fetch(dataURL)
  //   .then(res2 => res2.json())
  //   .then(res2 => {
  //     this.setState({
  //       events: res2
  //     })
  //     // console.log(res2);
  //   })
  // }

   open = (e, ref) => {
      e.preventDefault()
      this.setState({ open: (ref===this.state.open) ? 0 : ref })
   }

   renderImage = (feather_style, style) => {
      return (
         <div className="featured-event-image">
           <div className="featured-image-feather feather-oval" style={feather_style}></div>
           <div className="featured-image-background" style={style}></div>
         </div>
      )
   }

   renderImageLink = (single_page, feather_style, style) => {
      return (
         <a className="featured-event-image-a" href={single_page}>
          {this.renderImage(feather_style, style)}
         </a>
      )
   }

   renderEvent = (event, i) => {
      // const { title, date, end_date, time, venue, event_description, links, gallery } = event
      const {
        //  title = 'Test Event',
         date = '20171212',
         end_date = '20171230',
        //  time = '6pm',
         location = 'Carnegie Hall',
         description = '<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sint asperiores ratione ea nesciunt maxime, ab in, minima, quidem soluta dignissimos totam veritatis! Voluptatum provident repellat commodi excepturi earum expedita tempora.</p>',
        //  links = null,
         gallery = [{url:'https://source.unsplash.com/random/800x500', caption:'test caption'}],
         single_page = false
      } = event.acf
      const title = event.title.rendered
      // console.log(event.slug);

      const formatted_date = (end_date) ? format(date,'M.D')+'–'+format(end_date,'M.D') : format(date,'ddd M.D')
      const featured_image = gallery[0]
      const ref = 'featured-event-'+(i+1)
      const openClass = (ref===this.state.open) ? 'featured-event-open' : 'featured-event-closed'

      const style = {
         backgroundImage:`url(${featured_image.sizes['tdn-medium']})`
      }
      const feather_style = {
         backgroundImage: `url(${gradient_oval})`
      }

      const imageLink = (single_page) ? this.renderImageLink(single_page, feather_style, style) : this.renderImage(feather_style, style)

      return (
         <div key={i} className={`featured-event use-gpu ${openClass}`}>
            <div className="featured-event-gradient"></div>
            <div className="divider divider-dashed divider-orange"><svg width="100%"><line x1="100%" y1="0%" x2="0%" y2="0%" stroke="#fff" strokeWidth="1"></line></svg></div>

            <div className={`event-inner page-width`}>

               <div className="col s12">
                  <div className="featured-event-square"><IconSquare color="white" size="28px"/></div>
                  <h2 onClick={(e) => this.open(e, ref)}>{ReactHtmlParser(title)}</h2>
               </div>

               <div className="row featured-event-expanded">
                  <div className="col s12 m4">
                     <div className="featured-event-description">
                      { formatted_date }<br/>
                      { location }<br/>
                     {ReactHtmlParser(description)}


                     <br/>
                     {single_page && <a href={single_page}><div className="read-more-button">Read more</div></a>}
                     {/* {single_page && <Link to={single_page}><div className="read-more-button">Read more</div></Link>} */}

                     </div>
                  </div>

                  {/* <div className="col s12 m1"></div> */}

                  <div className="col s12 m8">
                     <div className="featured-event-image-position2">

                        {imageLink}

                     </div>
                  </div>
               </div>

            </div>
         </div>
      )
   }

   render() {
      const title = 'Featured Events'

      return (
         <div className="SectionFeaturedEvents" id="events">

           <div className="page-width"><div className="section-title divider-title">{title}</div></div>

           <div className="featured-events">
             { this.props.events.map((event, i) => event.acf.featured_event && this.renderEvent(event, i)) }
           </div>

         </div>
      )
   }
}

export default SectionFeaturedEvents



// WEBPACK FOOTER //
// ./src/components/SectionFeaturedEvents.js